import PropTypes from 'prop-types';

export const i18n = PropTypes.shape({
  getString: PropTypes.func.isRequired,
});

export const tileFooterConfigShape = PropTypes.shape({
  isRequired: PropTypes.bool,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    callback: PropTypes.func,
  })),
  PageNavigator: PropTypes.func,
});

export const tileHeaderConfigShape = PropTypes.shape({
  isRequired: PropTypes.bool,
  isLargeHeader: PropTypes.bool,
  renderHeaderText: PropTypes.func,
  actions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    callback: PropTypes.func,
  })),
  i18n: i18n.isRequired,
  as: PropTypes.elementType,
  moreOptionsLabel: PropTypes.string,
  actionComponentType: PropTypes.oneOf(['OverflowSet', 'DropdownButton']),
});

export const tileContentConfigShape = PropTypes.shape({
  styles: PropTypes.shape({
    root: PropTypes.shape({
      width: PropTypes.string,
      height: PropTypes.string,
    }),
  }),
  shimmerLineCount: PropTypes.number,
  onRenderShimmer: PropTypes.func,
  isShimmerRequired: PropTypes.bool,
});
